export const signInInput = (hasError: boolean) =>
  `tw:w-full tw:text-center tw:text-base tw:bg-transparent tw:py-3 tw:px-4 tw:border-0 tw:border-b tw:transition-colors tw:outline-none tw:focus:border-primary tw:placeholder:text-gray-400 ${
    hasError ? 'tw:border-destructive' : 'tw:border-gray-300'
  }`;

const inlineLinkBase =
  'tw:underline tw:bg-transparent tw:border-0 tw:p-0 tw:cursor-pointer tw:hover:opacity-80';

export const inlineLink = `tw:text-primary ${inlineLinkBase}`;

export const inlineLinkMuted = `tw:text-gray-600 ${inlineLinkBase}`;

export const inlineLinkError = `tw:text-destructive ${inlineLinkBase}`;
